const shortcuts = [
  {
    id: 5,
    title: "Book Private Mediumship Session",
    src: "./clientdashboardimages/2.png",
    alt: "card",
    url:'/appointment',
    type:'tab',
  },
  {
    id: 10,
    title: "Book Group Event",
    src: "./clientdashboardimages/2.png",
    alt: "card",
    url:'/go-on-demand-practice',
    type:'tab',
  },
  {
    id: 8,
    title: "Purchase Gift Cards\n(Gifts of Love)",
    className: "gift-card-shortcut",
    src: "./clientdashboardimages/download.svg",
    alt: "card",
    url:'/give-a-gift',
    type:'tab',
  },
  {
    id: 1,
    title: "Find Meeting Link",
    src: "./clientdashboardimages/1.png",
    alt: "card",
    url:'/appointments',
    type:'tab',
  },
  {
    id: 2,
    title: "Cancel/Change Booking",
    src: "./clientdashboardimages/2.png",
    alt: "card",
    url:'/appointments',
    type:'tab',
  },
  {
    id: 3,
    title: "Give Medium Feedback",
    src: "./clientdashboardimages/3.png",
    alt: "card",
    url:'/appointments',
    type:'tab',
  },
  {
    id: 4,
    title: "Pay My Medium",
    src: "./clientdashboardimages/4.png",
    alt: "card",
    url:'/appointments',
    type:'tab',
  },
  {
    id: 6,
    title: "Get Help or Report Issue",
    src: "./clientdashboardimages/5.png",
    alt: "card",
    url:'https://support.verysoul.com/',
    type:'mail',
  },
];

export { shortcuts };
